'use es6';

import PropTypes from 'prop-types';
import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import TrackDeprecatedDescription from '../../TrackCard/TrackDeprecatedDescription';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackDeprecatedModal = ({
  trackId,
  message,
  cta
}) => /*#__PURE__*/_jsxs(Modal, {
  "data-test-id": "track-deprecated-modal",
  size: "auto",
  children: [/*#__PURE__*/_jsx(DialogHeader, {
    children: /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.deprecations.notAvailableShort"
      })
    })
  }), /*#__PURE__*/_jsx(DialogBody, {
    children: /*#__PURE__*/_jsx(TrackDeprecatedDescription, {
      cta: cta,
      message: message,
      trackId: trackId
    })
  }), /*#__PURE__*/_jsx(DialogFooter, {
    align: "center",
    children: /*#__PURE__*/_jsx(UIRouterButton, {
      to: "/",
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.backToTracks.link"
      })
    })
  })]
});
TrackDeprecatedModal.propTypes = {
  cta: PropTypes.string,
  message: PropTypes.string,
  trackId: PropTypes.string.isRequired
};
export default TrackDeprecatedModal;